"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _constants = require("../Button/constants");

var _Truncate = _interopRequireDefault(require("../Truncate"));

var _constants2 = require("./constants");

var _styled = require("./styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var NavItem = function NavItem(props) {
  var children = props.children,
      disabled = props.disabled,
      icon = props.icon,
      index = props.index,
      ignoreMinimal = props.minimal,
      selected = props.selected,
      type = props.type,
      restProps = _objectWithoutPropertiesLoose(props, ["children", "disabled", "icon", "index", "minimal", "selected", "type"]);

  var rootProps = _objectSpread({
    'aria-disabled': disabled,
    'aria-current': selected ? 'page' : undefined,
    circular: type === _constants2.INTERNAL_TYPE.pills,
    'data-index': index,
    disabled: disabled,
    iconStart: icon,
    selected: selected,
    size: type === _constants2.INTERNAL_TYPE.pills ? _constants.SIZE.small : type === _constants2.INTERNAL_TYPE.tabs ? _constants.SIZE.medium : _constants.SIZE.large,
    type: type
  }, restProps);

  return (0, _core.jsx)(_styled.NavItemRoot, rootProps, (0, _core.jsx)(_Truncate.default, null, children));
};

NavItem.displayName = 'NavItem';
var _default = NavItem;
exports.default = _default;